import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../components/layouts/dashboardLayout'
import { Breadcrumb } from 'react-bootstrap';
import RLDD from 'react-list-drag-and-drop/lib/RLDD';
import Offcanvas from 'react-bootstrap/Offcanvas';
import AppApi from "../../api/app";
import toast from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import Actions from '../../store/actions';
import { MdOutlineDragIndicator } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { useNavigate, useParams } from 'react-router-dom';
import AddSubCategory from '../../components/forms/addSubcategory';
import routes from '../../utils/routes';

let updateInterval = "";
let Subcategory = () => {
   let navigate = useNavigate()
   const prams = useParams();
   let profile = useSelector(data => data.profile.data);
   let categories = useSelector(data => data.categories);
   const [show, setShow] = useState(false);
   const [data, setData] = useState([]);
   const [loading, setLoading] = useState();
   const [category, setCategory] = useState({});
   const [activeCategory, setActiveCategory] = useState({});

   useEffect(() => {
      if (categories) {
         let activeCategory = categories?.data?.findIndex(data => data?._id == prams?.id)
         if (activeCategory >= 0) {
            setActiveCategory(categories?.data[activeCategory]);
         }
      }
   }, [categories])

   useEffect(() => {
      getSubcategories();
   }, [])

   const getSubcategories = () => {
      try {
         setLoading(true)
         AppApi.getSubcategories(prams.id)
            .then(async (res) => {
               if (res?.status == 200) {
                  setData(await updateListOrder(res?.data?.data?.data));
               }
               setLoading(false)
            })
      } catch (error) {
         setLoading(false)
         console.log(error.message);
      }
   }

   let updateSubcategoryListOrder = (list) => {
      try {
         AppApi.updateSubcategoriesListOrder({ subcategories: list })
            .then(async (res) => {
               if (res?.status == 200) {
                  toast.success("Subcategory order list updated successfully.");
               }
            })
      } catch (error) {
         console.log(error.message);
      }
   }
   let updateList = async (subcategory, remove = false) => {
      let list = data;
      if (remove) {
         list = list.filter(item => item._id != subcategory?._id);
      } else {
         if (category?._id) {
            let index = await list.findIndex(item => item?._id == subcategory?._id);
            if (index > -1) {
               list[index] = subcategory
            }
         } else {
            list = [subcategory, ...list]
         }
      }
      list = await updateListOrder(list)
      console.log({ list })
      setData(list)
      setShow(false);
   }

   let updateListOrder = async (data) => {
      let list = await data?.map((data, index) => { return { ...data, id: index } })
      return list
   }

   let editCategory = (data) => {
      setCategory(data);
      setShow(true);
   }

   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-4">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Category</Breadcrumb.Item>
                        {activeCategory?.name && (
                           <Breadcrumb.Item active>
                              {activeCategory?.name}
                           </Breadcrumb.Item>
                        )}
                     </Breadcrumb>
                  </div>
               </div>
               <div className="row">
                  <div className="col-12">
                     <div className='categoryCardWrapper pointer'>
                        <div className='bannerWrapper'>
                           {activeCategory?.banner && (
                              <img src={activeCategory?.banner} alt="" />
                           )}
                           <div className='iconWrapper'>
                              {activeCategory?.icon && (
                                 <img src={activeCategory?.icon} className="icon" alt="" />
                              )}
                           </div>
                           {activeCategory?.hide && (
                              <span className="badge text-bg-dark rounded-0 hiddenInfo">Hidden</span>
                           )}
                        </div>
                        <div className="detailsWrapper" >
                           <div className="contentWrapper">
                              <h6 className='mb-0'>{activeCategory?.name}</h6>
                              <p className='text-truncate'>{activeCategory?.description}</p>
                           </div>
                        </div>
                     </div>

                     <div className=" p-3 overflow-hidden">
                        <div className="d-flex justify-content-between border-bottom pb-2">
                           <div>
                              <h4>Subcategories</h4>
                           </div>
                           <div className='d-flex gap-2'>
                              <div>
                                 <button className='btn rounded-0 btn-dark'
                                    onClick={() => { navigate(routes.category) }}
                                 >Back</button>
                              </div>
                              <div>
                                 <button className='btn rounded-0 btn-dark'
                                    onClick={() => { editCategory({}); setShow(true) }}
                                 >Add New</button>
                              </div>
                           </div>
                        </div>
                        <br />
                        {loading && (
                           <div className='pageSimpleLoader'>
                              Loading...
                           </div>
                        )}
                        {!loading && data.length == 0 && (
                           <div className='pageSimpleLoader'>
                              No record found
                           </div>
                        )}
                        {data.length > 0 && (
                           <div className="listedWrapper">
                              <RLDD
                                 items={data}
                                 itemRenderer={(data, index) => {
                                    return (
                                       <div className='categoryCardWrapper' key={data?.id}>
                                          <div className='actionWrapper' onClick={() => editCategory(data)}>
                                             <AiOutlineEdit className='pointer' />
                                          </div>

                                          <div className='bannerWrapper'>
                                             {data?.banner && (
                                                <img src={data?.banner} alt="" />
                                             )}
                                             <div className='iconWrapper'>
                                                {data?.icon && (
                                                   <img src={data?.icon} className="icon" alt="" />
                                                )}
                                             </div>
                                             <div className='viewDetailsLink'>
                                                <a
                                                   href={"https://" + profile?.domain + `/${activeCategory?.slug}/${data.slug}`}
                                                   target="_blank" rel="noopener noreferrer">View</a>
                                             </div>
                                             {data?.hide && (
                                                <span className="badge text-bg-dark rounded-0 hiddenInfo">Hidden</span>
                                             )}
                                          </div>
                                          <div className="detailsWrapper" key={index} >
                                             <div className="contentWrapper">
                                                <h6 className='mb-0'>{data?.name}</h6>
                                                <p className='text-truncate'>{data?.description}</p>
                                             </div>
                                          </div>
                                       </div>
                                    );
                                 }}
                                 onChange={(data) => {
                                    console.log(data);
                                    setData(data)
                                    if (updateInterval) {
                                       clearTimeout(updateInterval)
                                    }
                                    updateInterval = setTimeout(() => {
                                       updateSubcategoryListOrder(data)
                                       clearTimeout(updateInterval)
                                    }, 2000);
                                 }}
                              />
                           </div>
                        )}
                        <br />
                        <br />
                     </div>
                  </div>
               </div>

            </div>
         </DashboardLayout>
         <Offcanvas show={show} placement="end" onHide={() => setShow(false)}>
            <Offcanvas.Header closeButton>
               <Offcanvas.Title>Add Subcategory</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
               <AddSubCategory updateList={updateList} category={category} id={prams?.id} />
            </Offcanvas.Body>
         </Offcanvas>
      </>
   )
}

export default Subcategory